export enum ProjectTypes {
  PricingTime = 1,
  OilProject = 2,
  AdminTime = 3,
  TrainingTime = 4,
  TravelTimeToStore = 5,
  Other = 6,
  TravelTimeToHome = 7,
}

export class ProjectType {
  id: number
  name: string
  sort_order: number
  
  constructor() {
  }

  static buildOne(obj: any): ProjectType {
    let target: ProjectType = Object.assign(new ProjectType(), obj)
    return target
  }

  static buildMany(objs: any[]): ProjectType[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ProjectType.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

